import type { ShiftMarketplaceRequest } from '../types';

export const ACTIVE_MARKETPLACE_STATUSES = new Set(['Open', 'Accepted', 'PendingApproval']);

export function indexMarketplaceByShiftId(
  requests: ShiftMarketplaceRequest[]
): Map<number, ShiftMarketplaceRequest> {
  const map = new Map<number, ShiftMarketplaceRequest>();
  for (const r of requests) {
    if (!ACTIVE_MARKETPLACE_STATUSES.has(r.status)) continue;
    map.set(r.offeredShiftId, r);
    if (r.requestedShiftId) map.set(r.requestedShiftId, r);
  }
  return map;
}

export function marketplaceSchedulerBadge(r: ShiftMarketplaceRequest): string {
  const swap = r.requestType === 'Swap';
  if (r.status === 'PendingApproval') return swap ? 'Swap pending' : 'Cover pending';
  return swap ? 'Swap offered' : 'Cover offered';
}

export function marketplaceOffererBadge(r: ShiftMarketplaceRequest): string {
  const swap = r.requestType === 'Swap';
  const who = r.acceptedByName;
  if (r.status === 'PendingApproval') {
    return swap
      ? `Swap pending approval${who ? ` with ${who}` : ''}`
      : `Cover pending approval${who ? ` — ${who}` : ''}`;
  }
  return swap ? 'Swap offered' : 'Offered for cover';
}

export function marketplaceAccepterBadge(r: ShiftMarketplaceRequest): string {
  const swap = r.requestType === 'Swap';
  const who = r.offeredByName;
  if (r.status === 'PendingApproval') {
    return swap
      ? `Swap pending approval${who ? ` with ${who}` : ''}`
      : `Cover pending approval${who ? ` from ${who}` : ''}`;
  }
  return swap ? 'Swap requested' : 'Cover accepted — awaiting manager';
}

export function marketplaceEditLockTitle(r: ShiftMarketplaceRequest): string {
  const kind = r.requestType === 'Swap' ? 'Swap' : 'Cover';
  if (r.status === 'PendingApproval') {
    return `${kind} pending approval — use Marketplace Approvals`;
  }
  return `${kind} offered — resolve on Marketplace Approvals before editing`;
}
